// extracted by mini-css-extract-plugin
export default {"itemList":"ItemList_itemList__iuEKJ","table":"ItemList_table__Sneqc","header":"ItemList_header__VWzR0","row":"ItemList_row__PDpam","cell":"ItemList_cell__vdfQF"};